import { AxiosResponse } from 'axios';
import api from './axiosConfig';
import { ProductCategory } from '../types/entities';

/** Catálogo global do sistema: não muda por usuário e não tem mutação no front. */
export const CHAVES_CATEGORIAS_PRODUTO = {
  todas: ['categorias-produto'] as const,
};

const ProductCategoryService = {
  // GET /api/v1/product-categories
  getAll: (): Promise<AxiosResponse<ProductCategory[]>> =>
    api.get('/product-categories'),
};

export default ProductCategoryService;
